import { render, staticRenderFns } from "./BdTableWeb.vue?vue&type=template&id=c72a9d24&scoped=true&"
import script from "./BdTableWeb.vue?vue&type=script&lang=js&"
export * from "./BdTableWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72a9d24",
  null
  
)

export default component.exports